import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { ContestEntriesContent } from '@/pageContents/contestEntries/ContestEntriesContent';

const ContestEntriesPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Gewinnspiel | Starjack Backoffice</title>
            </Helmet>

            <ContestEntriesContent />
        </>
    );
};

ContestEntriesPage.isProtected = true;
ContestEntriesPage.permissions = [Permission.ADMIN];
ContestEntriesPage.getLayout = (Component) => (
    <SidebarLayout>{Component}</SidebarLayout>
);

export default ContestEntriesPage;
